export default [
  {
    name: 'snek_cardano_3831f600',
    displayName: 'Snek',
    decimals: 0,
    ticker: 'SNEKcardano3831F600',
    displayTicker: 'SNEK',
    assetId: '279c909f348e533da5808898f87f9a14bb2c3dfbbacccd631d927a3f534e454b', // policyId + hexName
    info: {
      description:
        'Sustainable and inclusive token on the Cardano blockchain, providing a fun and rewarding experience to our community. A meme coin.',
      twitter: 'https://twitter.com/snekcoinada',
      website: 'https://www.snek.com/',
      telegram: 'https://t.me/snekcoinada',
    },
    primaryColor: '#00E1FF',
    gradientColors: ['#00E1FF', '#A6F4FF'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '20%', y2: '20%' },
  },
  {
    name: 'test_cardano',
    displayName: 'Test Coin',
    decimals: 0,
    ticker: 'TESTADA',
    assetId: 'be56327ce04e3fd77a3d3bb5387f14be730ed4ec151bae2dea5b6c9a74657374', // policyId + hexName
    info: {
      description: 'Test native token on the ADA blockchain.',
    },
    primaryColor: '#FB3EF3',
    gradientColors: ['#FF9AFB', '#FB3EF3'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '100%', y2: '100%' },
  },
  {
    name: 'worldmobil_cardano_262abe57',
    displayName: 'World Mobile Token',
    decimals: 6,
    ticker: 'WORLDMOBILcardano262ABE57',
    displayTicker: 'WMT',
    assetId:
      '1d7f33bd23d85e1a25d87d86fac4f199c3197a2f7afeb662a0f34e1e776f726c646d6f62696c65746f6b656e', // policyId + hexName
    info: {
      description:
        'WMT is used for the rewards system that powers World Mobile, a revolutionary telecom network that aims to bring the internet to billions of people. WMT can be earned by operating a node, processing transactions, and staking WMT.',
      reddit: 'https://reddit.com/r/WorldMobileToken',
      twitter: 'https://twitter.com/wmtoken?lang=en',
      website: 'https://worldmobiletoken.com',
      telegram: 'https://t.me/WorldMobileTeam',
    },
    primaryColor: '#B441CE',
    gradientColors: ['#4A148C', '#B441CE'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '100%', y2: '100%' },
  },
]
